module.exports = __webpack_public_path__ + "img/guide_self_test.6d9f8284.svg";